import { FetchAllSlots, useQueryAllSlots } from '@@partner:graphql/query/shop/allSlots.gql'
import useFetchMorePagination from '@@partner:helpers/hooks/useFetchMorePagination'
import { formatShortDate } from '@@partner:helpers/util'
import { GQL_ID, NestedFilter } from '@@partner:types:graphql'
import React, { useCallback, useMemo, useRef, useState } from 'react'
import { Form, SelectPicker } from 'rsuite'

type BasicProps = {
  zone_id?: GQL_ID
  shop_id: GQL_ID
  value?: GQL_ID
  onChange: (value: GQL_ID | null) => void
  className: string
}

const now = Date.now()

export default function SelectSlotPicker ({
  value,
  onChange,
  zone_id,
  shop_id,
  className
}: BasicProps) {
  const [ page, setPage ] = useState(1)
  const [ limit, setLimit ] = useState(100)

  const zoneOrShopFilter: NestedFilter = zone_id ? {
    fields: [ 'zone_id' ],
    op: 'eq',
    value: Number(zone_id)
  } : {
    fields: [ 'shop_id' ],
    op: 'eq',
    value: [ shop_id ]
  }

  const ref = useRef(null)

  const { data, loading, error, refetch, fetchMore } = useQueryAllSlots({
    filter: {
      and: [
        zoneOrShopFilter,
        {
          fields: [ 'ts_start' ],
          op: 'gte',
          value: [ now ]
        }
      ]
    },
    pager: {
      limit,
      page
    },
    sort: {
      fieldName: 'ts_start',
      direction: 1
    }
  })

  const updaterFunction = useCallback((cached: FetchAllSlots, fetched: FetchAllSlots) => {
    const prev = cached?.allSlots?.edges ?? []
    const curr = fetched?.allSlots?.edges ?? []

    return {
      hasMore: curr.length > 0,
      result: {
        orderedProducts: {
          ...fetched.allSlots,
          edges: [ ...prev, ...curr ]
        }
      }
    }
  }, [])

  const { hasMore, fetchNextPage } = useFetchMorePagination({
    fetchMore,
    updaterFunction,
    usePager: true,
    pageVariable: 'pageInfo'
  })

  const slotsData = useMemo(() => {
    return (data?.allSlots.edges ?? []).map(slot => ({
      ...slot,
      label: `${slot.slotDate} ${slot.slotTime}`
    }))
  }, [ data?.allSlots.edges ])
  
  return (
    <Form.Group className={className}>
      <Form.ControlLabel>Изменить слот</Form.ControlLabel>
      <SelectPicker
        ref={ref}
        value={value}
        data={slotsData}
        onChange={onChange}
        onOpen={refetch}

        searchable={true}
        placeholder="Слот"
        valueKey="id"
        labelKey="label"
      />
    </Form.Group>

  )
}